import * as React from 'react';

import { IAvgPriceInformer, IQuickLink } from '../../../common/state';
import { trackQuickLinksView } from './utils/tracking';

import { IJsonQuery } from '../../../json_query';
import { QuickLinksList } from './components/QuickLinksList/QuickLinksList';
import { QuickLinksCommercialCalc } from './components/QuickLinksCommercialCalc';
import { QuickLinksSuburbanTrap } from './components/QuickLinksSuburbanTrap';
import * as styles from './QuickLinks.css';

type TDealType =
  | 'flatrent'
  | 'flatsale'
  | 'newobjectsale'
  | 'commercialrent'
  | 'commercialsale'
  | 'suburbanrent'
  | 'suburbansale';

export interface IQuickLinksStateProps {
  avgPriceInformer: IAvgPriceInformer | null;
  jsonQuery: IJsonQuery;
  level: number | null;
  linkGroups: IQuickLink[][] | null;
  priceSm?: boolean;
  dealType: TDealType;
  isOfficeCalculatorButtonVisible: boolean;
  countrysideLink?: string;
  isCountrysideTrapEnabled: boolean;
}

export interface IQuickLinksDispatchProps {
  onOfficeCalculatorButtonClick(): void;
}

export interface IQuickLinksProps extends IQuickLinksStateProps, IQuickLinksDispatchProps {
  level: number;
  linkGroups: IQuickLink[][];
}

export class QuickLinks extends React.PureComponent<IQuickLinksProps> {
  public componentDidMount() {
    trackQuickLinksView(this.props.level);
  }

  public render() {
    const {
      avgPriceInformer,
      jsonQuery,
      dealType,
      isOfficeCalculatorButtonVisible,
      onOfficeCalculatorButtonClick,
      level,
      linkGroups,
      priceSm,
      countrysideLink,
      isCountrysideTrapEnabled,
    } = this.props;

    const coworkingOfferType = jsonQuery.coworking_offer_type && jsonQuery.coworking_offer_type.value;
    const isShowQuickLinks = !(coworkingOfferType && coworkingOfferType.length > 0);

    return (
      <div className={styles['wrapper']}>
        <QuickLinksCommercialCalc
          avgPriceInformer={avgPriceInformer}
          jsonQuery={jsonQuery}
          dealType={dealType}
          isOfficeCalculatorButtonVisible={isOfficeCalculatorButtonVisible}
          onOfficeCalculatorButtonClick={onOfficeCalculatorButtonClick}
          priceSm={priceSm}
        />

        {isShowQuickLinks && <QuickLinksList linkGroups={linkGroups} level={level} />}

        <QuickLinksSuburbanTrap
          jsonQuery={jsonQuery}
          isCountrysideTrapEnabled={isCountrysideTrapEnabled}
          countrysideLink={countrysideLink}
        />
      </div>
    );
  }
}
